import * as $ from 'jquery';
import { isLogged, redirectAnonymous } from "../utils";
import { userReportRequest, userBlockRequest, userUnblockRequest } from '../api/api_user';

export const userReportBlock = {

    userReport: async (userName) => {
        const modalReportUser = document.getElementById("modal-user-report");
        await userReportRequest(userName);
        $(modalReportUser).modal('show');
    },

    userBlock: async (userId, userBlocked, popover) => {
        const response = userBlocked
            ? await userUnblockRequest(userId)
            : await userBlockRequest(userId) 
            
        if (response && response.ok) {
            const warningMessage = document.querySelector('.js-warning-user-blocked');
            warningMessage?.classList.toggle('d-none', userBlocked);
            popover.dataset.userBlocked = !userBlocked;
        }
    },

    init: () => {
        const popoverElement = document.querySelector('.js-report-block-user');
        const userId = popoverElement?.dataset.userId;
        const userName = popoverElement?.dataset.userName;

        if (popoverElement) {
            popoverElement.addEventListener('click', (e) => {
                if (!isLogged()) {
                    $('.popover').popover('hide');
                    e.stopImmediatePropagation();
                    if (redirectAnonymous()) { return; }
                }
            })

            $(popoverElement).on('shown.bs.popover', (e) => {
                const linkReport = document.querySelector('.js-report-user');
                const linkBlock = document.querySelector('.js-block-user');
                const textBlock = linkBlock?.querySelector('span');
                const userBlocked = popoverElement?.dataset.userBlocked === 'true';
                userBlocked
                    ? textBlock.textContent = 'Desbloquear a este usuario'
                    : textBlock.textContent = 'Bloquear a este usuario';

                linkReport.addEventListener('click', () => {
                    $(e.target).popover('hide');
                    userReportBlock.userReport(userName);
                });

                linkBlock.addEventListener('click', () => {
                    $(e.target).popover('hide');
                    userReportBlock.userBlock(userId, userBlocked, popoverElement);

                });

            });

        }
    }

};
